module.exports = __webpack_public_path__ + "assets/img/JQ-ico-8.60bf084c.png";